import CodonationBox from './CodonationBox'
export default CodonationBox
